import React from "react";
import { UIFilterPanel, UIInput, UIButton, UICheckbox, UISelect, UIInputGroup } from "../../../components/guiElements";
import { orderByKeys } from "./orderByKeys";

export default function WarehouseFilters({ fields, values, labels, onChange, onSearch, onClear, order = [], advancedKeys = [], advancedOpen = false, onAdvancedToggle, className = "" }) {
    const renderField = ([key, field]) => {
        const value = values[key];
        const label = field.label ?? labels[key];

        switch (field.type) {
            case "select":
                return (
                    <UISelect
                        key={key}
                        filterKey={key}
                        name={key}
                        options={field.options}
                        value={value}
                        onChange={onChange}
                    />
                );

            case "checkbox":
                return (
                    <UICheckbox
                        key={key}
                        filterKey={key}
                        name={key}
                        value={value}
                        label={label}
                        onChange={onChange}
                    />
                );

            case "inputGroup":
                return (
                    <UIInputGroup
                        key={key}
                        filterKey={key}
                        className="stock-quantity-filter"
                        leftName={`${key}.Comparison`}
                        leftValue={value?.Comparison ?? ""}
                        leftOptions={field.options}
                        rightType="number"
                        rightName={`${key}.Value`}
                        rightValue={value?.Value ?? ""}
                        hint={label}
                        onChange={onChange}
                    />
                );

            case "button":
                return (
                    <UIButton
                        key={key}
                        filterKey={key}
                        text={label}
                        onClick={onSearch}
                        className="filter-button"
                    />
                );

            case "clearButton":
                return (
                    <UIButton
                        key={key}
                        filterKey={key}
                        text={label}
                        onClick={onClear}
                        className="filter-button secondary"
                    />
                );

            default:
                return (
                    <UIInput
                        key={key}
                        filterKey={key}
                        type={field.type}
                        name={key}
                        maxDate={new Date()}
                        value={value}
                        hint={label}
                        onChange={onChange}
                    />
                );
        }
    };

    const entries = orderByKeys(Object.entries(fields), order, ([key]) => key);

    const mainFields = entries.filter(([key]) => !advancedKeys.includes(key)).map(renderField);

    const advancedFields = entries.filter(([key]) => advancedKeys.includes(key)).map(renderField);

    return (
        <UIFilterPanel
            className={className}
            advancedOpen={advancedOpen}
            onAdvancedToggle={onAdvancedToggle}
            advancedContent={
                advancedOpen ? advancedFields : []
            }
        >
            {mainFields}
        </UIFilterPanel>
    );
}